module.exports = __webpack_public_path__ + "99907c58a378b4e4d1fcbf8e1f42f58c.jpg";